<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="手机号码">
                  <el-input style="width: 200px;" v-model="queryForm.userMobile"></el-input>
              </el-form-item>
              <el-form-item label="订单ID">
                  <el-input style="width: 200px;" v-model="queryForm.withdrawId"></el-input>
              </el-form-item>
              <el-form-item label="审核状态">
<!--                  <el-input  v-model="queryForm.status"></el-input>-->
                  <el-select v-model="queryForm.status" placeholder="请选择" clearable style="width: 200px;">
                    <el-option
                      label="待审核"
                      :value="1"
                    ></el-option>
                      <el-option
                          label="提现成功"
                          :value="2"
                      ></el-option>
                      <el-option
                          label="提现失败"
                          :value="3"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopThirdWithdrawList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopThirdWithdraw"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopThirdWithdraw(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopThirdWithdraw(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopThirdWithdrawList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopThirdWithdrawList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopThirdWithdrawList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="id"-->
<!--        label="ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userMobile"
        label="手机号码"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="withdrawId"
        label="订单ID"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="withdrawMoney"
        label="提现金额"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="审核状态"
      >
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? '待审核' : scope.row.status === 2 ? '提现成功' : '提现失败' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="error"
        label="错误"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="statusPd(scop.row.id, scop.row.withdrawMoney, scop.row.userMobile)" v-if="scop.row.status === 1">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">审核</span>
              </div>
            <div @click="checkShopThirdWithdraw(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopThirdWithdraw(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteShopThirdWithdraw(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopThirdWithdrawStates[shopThirdWithdrawState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopThirdWithdraw"
          ref="shopThirdWithdrawForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="手机号码"
            prop="userMobile"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdWithdraw.userMobile"
              :disabled="shopThirdWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单ID"
            prop="withdrawId"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdWithdraw.withdrawId"
              :disabled="shopThirdWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="提现金额"
            prop="withdrawMoney"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdWithdraw.withdrawMoney"
              :disabled="shopThirdWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="审核状态"
            prop="status"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopThirdWithdraw.status"-->
<!--              :disabled="shopThirdWithdrawState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                v-model="shopThirdWithdraw.status"
                placeholder="请选择"
                size="small"
                clearable
                style="width: 200px;"
                :disabled="shopThirdWithdrawState == 'check'"
              >
                  <el-option
                      label="待审核"
                      :value="1"
                  ></el-option>
                  <el-option
                      label="提现成功"
                      :value="2"
                  ></el-option>
                  <el-option
                      label="提现失败"
                      :value="3"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="错误"
            prop="error"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdWithdraw.error"
              :disabled="shopThirdWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopThirdWithdrawState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>


      <!--审核功能-->
      <el-dialog title='申请审核' :visible.sync='retreatDialogVisible' width='30%'
                 :before-close='handleCloseRetreat'>
          <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='120px'>
              <el-form-item label='是否同意：' prop='resource'>
                  <el-radio-group v-model='retreatForm.status'>
                      <el-radio :label='2'>同意</el-radio>
                      <el-radio :label='3'>拒绝</el-radio>
                  </el-radio-group>
              </el-form-item>
              <template v-if="retreatForm.status == 2">
                  <el-form-item label='提现金额：' prop='withdrawMoney'>
                      <el-input type="number" style='width: 200px' disabled v-model='retreatForm.withdrawMoney'></el-input>
                  </el-form-item>
                  <el-form-item label='抵扣悦果：' prop='money1'>
                      <el-input type="number" style='width: 200px' v-model='retreatForm.money1'></el-input>
                      <span>({{moneys.money1}})</span>
                  </el-form-item>
                  <el-form-item label='抵扣悦豆：' prop='money2'>
                      <el-input type="number" style='width: 200px' v-model='retreatForm.money2'></el-input>
                      <span>({{moneys.money2}})</span>
                  </el-form-item>
                  <el-form-item label='抵扣贡献值：' prop='money3'>
                      <el-input type="number" style='width: 200px' disabled v-model='retreatForm.money3'></el-input>
                      <span>({{moneys.money3}})</span>
                  </el-form-item>
              </template>
              <el-form-item label='拒绝原因：' v-if="retreatForm.status == 3" prop='desc'>
                  <el-input style='width: 100%' type='textarea' v-model='retreatForm.error'></el-input>
              </el-form-item>
              <!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
              <!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
              <!--                </el-form-item>-->
          </el-form>
          <span slot='footer' class='dialog-footer'>
        <el-button @click='handleCloseRetreat'>取 消</el-button>
        <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
      </span>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopThirdWithdrawList();
                    this.getShopThirdWithdrawList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopThirdWithdrawList();
                    this.getShopThirdWithdrawList();
                    this.$emit('resetCheckState');
                }
            },
            'retreatForm.money2':{
                handler(val, old) {
                    if(val < 0){
                        this.$message.warning('抵扣悦豆值不能为负数')
                        this.retreatForm.money2 = old;
                        return
                    }
                    let money3 = this.retreatForm.withdrawMoney - this.retreatForm.money1 - this.retreatForm.money2;
                    if(money3 < 0){
                        this.retreatForm.money3 = 0;
                        this.$message.warning('抵扣券不能为负数')
                        this.retreatForm.money2 = old;
                    }
                    this.retreatForm.money3 = this.retreatForm.withdrawMoney - this.retreatForm.money1 - this.retreatForm.money2;
                },
            },
            'retreatForm.money1':{
                handler(val, old) {
                    if(val < 0){
                        this.$message.warning('抵扣悦果值不能为负数')
                        this.retreatForm.money1 = old;
                        return
                    }
                    let money3 = this.retreatForm.withdrawMoney - this.retreatForm.money1 - this.retreatForm.money2;
                    if(money3 < 0){
                        this.retreatForm.money3 = 0;
                        this.$message.warning('抵扣券不能为负数')
                        this.retreatForm.money1 = old;
                    }
                    this.retreatForm.money3 = this.retreatForm.withdrawMoney - this.retreatForm.money1 - this.retreatForm.money2;
                },
            }
        },
    data() {
            return {
                queryForm:{
                     userMobile: '', //手机号码
                     withdrawId: '', //订单ID
                     withdrawMoney: '', //提现金额
                     status: '', //1待审核 2提现成功 3提现失败
                     error: '', //错误
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopThirdWithdrawState: 'add',
                shopThirdWithdrawStates: {
                    add: '新建三方提现',
                    check: '查看三方提现',
                    edit: '修改三方提现'
                },

                multipleSelection: [],
                shopThirdWithdrawList: [],
                shopThirdWithdraw: {
                    id: '', //ID
                    userMobile: '', //手机号码
                    withdrawId: '', //订单ID
                    withdrawMoney: '', //提现金额
                    status: '', //1待审核 2提现成功 3提现失败
                    error: '', //错误
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userMobile: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }],
                    withdrawId: [{ required: true, message: '订单ID不能为空', trigger: 'blur' }],
                    withdrawMoney: [{ required: true, message: '提现金额不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '1待审核 2提现成功 3提现失败不能为空', trigger: 'blur' }],
                    error: [{ required: true, message: '错误不能为空', trigger: 'blur' }],
                },

                retreatDialogVisible: false,
                retreatForm:{
                    id: "",
                    status: "",
                    error: '',
                    withdrawMoney: 0,
                    money1: 0,
                    money2: 0,
                    money3: 0
                },
                moneys:{
                    money1: 0,
                    money2: 0,
                    money3: 0
                },
                retreatRules: {
                    status: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                    error: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                    withdrawMoney: [{ required: true, message: '提现金额不能为空', trigger: 'blur' }],
                    money1: [{ required: true, message: '抵扣悦果不能为空', trigger: 'blur' }],
                    money2: [{ required: true, message: '抵扣悦豆不能为空', trigger: 'blur' }],
                    money3: [{ required: true, message: '抵扣贡献值不能为空', trigger: 'blur' }]
                },
            };
        },
        created() {
            this.getShopThirdWithdrawList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 审核取消按钮
            handleCloseRetreat() {
                this.retreatDialogVisible = false;
                this.retreatForm.error = '';//关闭后把选择的按钮置空
                this.retreatForm.status = '';
                this.retreatForm.id = '';
                this.retreatForm.withdrawMoney = 0;
                this.retreatForm.money1 = 0;
                this.retreatForm.money2 = 0;
                this.retreatForm.money3 = 0;
            },
            //审核确认按钮
            retreatSuccess() {
                this.$refs.retreatForm.validate((valid) => {
                    if (valid) {
                        get(`/shop/thirdwithdraw/auditWithdraw`, this.retreatForm).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.handleCloseRetreat();
                                this.resetShopThirdWithdrawList();
                                this.resetDialog();
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            },
            resetShopThirdWithdrawList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopThirdWithdrawList = [];
            },
            getMoneys(id){
                get(`/shop/thirdwithdraw/getMoneysByMobile`, {mobile: id}).then((res) => {
                    if (res.success) {
                        this.moneys.money1 = res.money9;
                        this.moneys.money2 = res.money8;
                        this.moneys.money3 = res.money2 * 100;
                    }else{
                        this.moneys.money1 = 0;
                        this.moneys.money2 = 0;
                        this.moneys.money3 = 0;
                    }
                });
            },
            statusPd(id, money, mobile){
                this.getMoneys(mobile);
                this.retreatDialogVisible = true;
                this.retreatForm.id = id;
                this.retreatForm.withdrawMoney = money
                this.retreatForm.money3 = money;
            },
            resetDialog() {
                this.shopThirdWithdrawState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userMobile: '', //手机号码
                      withdrawId: '', //订单ID
                      withdrawMoney: '', //提现金额
                      status: '', //1待审核 2提现成功 3提现失败
                      error: '', //错误
                };
                this.getShopThirdWithdrawList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopThirdWithdraw = {
                      id: '', //ID
                      userMobile: '', //手机号码
                      withdrawId: '', //订单ID
                      withdrawMoney: '', //提现金额
                      status: '', //1待审核 2提现成功 3提现失败
                      error: '', //错误
                };
            },
            submitForm() {
                if (this.shopThirdWithdrawState == 'add') {
                    this.$refs.shopThirdWithdrawForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/thirdwithdraw/add`,{ ...this.shopThirdWithdraw }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopThirdWithdrawList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopThirdWithdrawState == 'edit') {
                    this.$refs.shopThirdWithdrawForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/thirdwithdraw/edit`,{ ...this.shopThirdWithdraw }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopThirdWithdrawList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopThirdWithdraw() {
                this.showDialog = true;
                this.shopThirdWithdrawState = 'add';
            },
            checkShopThirdWithdraw(shopThirdWithdrawId) {
                console.log(shopThirdWithdrawId);
                this.currentShopThirdWithdrawId = shopThirdWithdrawId;

                this.getShopThirdWithdrawById();
                this.showDialog = true;
                this.shopThirdWithdrawState = 'check';
            },
            editShopThirdWithdraw(shopThirdWithdrawId) {
                console.log('shopThirdWithdraw', shopThirdWithdrawId);
                if (shopThirdWithdrawId) {
                    this.currentShopThirdWithdrawId = shopThirdWithdrawId;
                    this.getShopThirdWithdrawById();
                } else {
                    this.shopThirdWithdraw = { ...this.shopThirdWithdraw, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopThirdWithdrawState = 'edit';
            },
            deleteShopThirdWithdraw(shopThirdWithdrawId) {
                let ids = '';
                if (shopThirdWithdrawId) {
                    ids = shopThirdWithdrawId;
                } else {
                    ids = this.multipleSelection.map((shopThirdWithdraw) => shopThirdWithdraw.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/thirdwithdraw/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopThirdWithdrawList();
                                this.getShopThirdWithdrawList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopThirdWithdrawList() {
                this.resetShopThirdWithdrawList();
                this.getShopThirdWithdrawList();
            },
            getShopThirdWithdrawList(query = {}) {
                this.loading = true;
                get(`/shop/thirdwithdraw/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopThirdWithdrawList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopThirdWithdrawById() {
                get(`/shop/thirdwithdraw/get`,{ id: this.currentShopThirdWithdrawId }).then((res) =>{
                    if(res.success){
                      this.shopThirdWithdraw = { ...this.shopThirdWithdraw, ...res.shopThirdWithdraw };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopThirdWithdrawList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/thirdwithdraw/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/thirdwithdraw/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/thirdwithdraw/importData`,formData);
              this.refreshShopThirdWithdrawList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopThirdWithdrawList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopThirdWithdrawList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>